import tripEvents from '../config/events.constant';
import paymentsConst from './../../../constants/payments.constant';
import appCONST from '../../../constants/app.constants';

export default function TripCheckoutPaymentController(
    $scope,
    $rootScope,
    $timeout,
    $stateParams,
    tripOptionsService,
    paymentFactory,
    tripAPI,
    tripFactory,
    userService,
    tripCheckoutModel,
    railAmendmentService,
    tripCheckoutPaymentService,
    tripDetailsService,
    tripBookingModal,
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        isPaymentTypeDropdownVisible,
        isNonEditableCardSectionVisible,
        paymentsConst,
    });

    function isNonEditableCardSectionVisible() {
        return !!$scope.storedCard
            && $scope.storedCard.IsFullCreditCardDetailsRequired
            && (!$scope.cbModel || !$scope.cbModel.enterAfterApproval);
    }

    function $onInit() {
        vm.isCreditCardPaymentAlertVisible = isCreditCardPaymentAlertVisible();
        initializeScope();
    }

    function initializeScope() {
        $scope.$watch('selectedOption', (selectedOption) => {
            Object.assign(tripCheckoutModel, {selectedOption});
        }, true);

        $scope.getTemplateUrl = function() {
            return $scope.tripData.PaymentSystem === paymentsConst.PaymentSystem.Adflex ? 'app/modules/trip/templates/partials/checkout/checkout.payment.adflex.tmpl.html' : 'app/modules/trip/templates/partials/checkout/checkout.payment.tmpl.html';
        };

                const payment = {
                    methods: function() {
                        return $scope.tripData.PaymentMethods || [];
                    },
                    invoice: function() {
                        return _.findWhere(this.methods(), {Type: 'Invoice'});
                    },
                    ktCards: function() {
                        return _.findWhere(this.methods(), {Type: 'KT Credit Card'});
                    },
                    customerCards: function() {
                        return _.findWhere(this.methods(), {Type: 'Customer Credit Card'});
                    },
                    creditCards: $scope.tripData.CreditCards || [],
                    creditCardTypes: $scope.tripData.CreditCardTypes || [],
                };

                $scope.ccFormData = {};

                $scope.submitTried = false;
                $scope.descriptionRequired = true;

                $scope.countries = tripOptionsService.getCountries().slice();

                $scope.$on(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE, () => init());


                $scope.$on(tripEvents.UPDATE_CREDIT_CARDS, function(event, cardsData) {
                    $scope.tripData.CreditCardTypes.forEach(function(card) {
                        card.Price.Amount = _.findWhere(cardsData, {Id: card.Id}).Price.Amount;
                    });

                    $scope.paymentOptions = paymentFactory.setPaymentOptions(payment);
                });

                function init(firstInitialization) {
                    $scope.creditCardTypes = paymentFactory.setCreditCardTypes(payment);
                    $scope.creditCardType = $scope.creditCardTypes[0];
                    $scope.paymentOptions = paymentFactory.setPaymentOptions(payment, $scope.tripDetails.IsOfflineTrip);

                    if (firstInitialization && $scope.paymentOptions && $scope.paymentOptions.length) {
                        const [notSelectedOption] = $scope.paymentOptions;
                        $scope.selectedOption = angular.copy(notSelectedOption);
                    }

                    $scope.$parent.invoiceOnly = (function() {
                        const showFrom = payment.invoice() && payment.invoice().ShowSmallCreditCardForm;
                        if ($scope.paymentOptions.length === 1) {
                            return {
                                value: true,
                                showFrom,
                            };
                        }
                        return {
                            value: false,
                        };
                    }());

                    if (firstInitialization) {
                        setPaymentDetails();
                    }
                }

                $scope.isAmadeus = {
                    cars: $scope.tripDetails.Cars || [],
                    hotels: paymentFactory.lodashFindConverter(_.find($scope.tripDetails.Hotels, {Supplier: 2})),
                    flights: paymentFactory.lodashFindConverter(_.find($scope.tripDetails.Flights, {ServiceOption: {Id: 1}})),
                    itemsCount: function() {
                        return (this.cars.length + this.hotels.length + this.flights.length);
                    },
                };

                $scope.cardType = '';
                $scope.ccNumberSeparator = '/';
                $scope.showWarning = false;
                $scope.isCardExist = false;
                $scope.isCardUpdate = false;

                $scope.numberHalfForm = null;
                $scope.numberFullForm = null;
                $scope.cvvFullForm = null;

                if ($scope.tripData.ApprovalSettings) {
                    $scope.approvalRequired = $scope.tripData.ApprovalSettings.IsApprovalRequired;
                }

                $scope.cbModel = {
                    enterAfterApproval: false,
                    showCheckbox: false,
                    showCvvField: !$scope.approvalRequired || $scope.tripData.IsApproved,
                };

                $scope.actionData.getEnterAfterApproval = function() {
                    return $scope.cbModel.enterAfterApproval;
                };

                $scope.isAmendmentMode = railAmendmentService.isAmendmentMode();
                $scope.paymentSelectionDisabled = $scope.tripData.IsApproved || $scope.isAmendmentMode;

                $scope.$watch('ccFormData.country.value', function(val) {
                    const hotelSuppliers = $scope.tripDetails.Hotels.map((hotel) => hotel.Supplier);
                    if (_.contains(hotelSuppliers, 0)) {
                        $scope.zipPattern = (val === 'US')
                        ? paymentFactory.groupPattern.strictExpediaUsZipCode
                        : paymentFactory.groupPattern.strictExpediaZipCode;
                    } else {
                        $scope.zipPattern = (val === 'US')
                        ? paymentFactory.groupPattern.usZipCode
                        : paymentFactory.groupPattern.zipCode;
                    }
                });

                $scope.$watch('ccFormData.Holder', function(val) {
                    if (!$scope.checkoutForm.ccForm || !$scope.tripData.UseYourOwnCardOnly) {
                        return;
                    }
                    const nameParts = val.split(' ');
                    const matches = nameParts.some((part) => part.toLocaleLowerCase() === userService.getUser().LastName.toLocaleLowerCase());
                     if (matches) {
                        $scope.checkoutForm.ccForm.holder.$setValidity('differentHolder', true);
                    } else {
                        $scope.checkoutForm.ccForm.holder.$setValidity('differentHolder', false);
                    }
                });

                $scope.warning = function(toShow) {
                    $scope.showWarning = toShow;
                };

                $scope.extraCCType = function(selectedOption) {
                    return selectedOption.paymentMethod
                        && selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice
                        && payment.invoice().ShowSmallCreditCardForm;
                };

                $scope.fullCCForm = function(selectedOption) {
                    return selectedOption.paymentMethod
                        && selectedOption.paymentMethod !== paymentsConst.PaymentMethods.invoice
                        && !payment.customerCards().ShowSmallCreditCardForm;
                };

                $scope.halfCCForm = function(selectedOption) {
                    return selectedOption.paymentMethod
                        && ((selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice
                        && payment.invoice().ShowSmallCreditCardForm)
                        || (selectedOption.paymentMethod !== paymentsConst.PaymentMethods.invoice
                        && payment.customerCards().ShowSmallCreditCardForm));
                };

                $scope.isCardEditable = function(card) {
                    return [
                            paymentsConst.CardHolderType.organization,
                            paymentsConst.CardHolderType.department,
                        ].indexOf(card.HolderType) === -1;
                };

                $scope.isDebit = function(selectedOption) {
                    return [1, 4, 7].indexOf(parseInt(selectedOption.Type || selectedOption.cardTypeId, 10)) !== -1;
                };

                $rootScope.$on(tripEvents.LUGGAGE_CHANGED, function() {
                    updateTripCosts();
                });

                $scope.$on(tripEvents.TRIP_CANCEL_CHECKOUT_PROCESS, function() {
                    tripFactory.createEmptyLuggageData();
                    updateTripCosts();
                });

                $scope.$on(tripEvents.CANCEL_CHECKOUT_PROCESS, function() {
                    clearCardType();
                    tripFactory.createEmptyLuggageData();
                    updateTripCosts();
                });

                $scope.$watch('cbModel.enterAfterApproval', function(newValue, oldValue) {
                    if (oldValue === true && newValue === false) {
                        initSpreedly($scope.selectedOption);
                    }
                });

                function initSpreedly(selectedOption) {
                    if ($scope.tripData.PaymentSystem === paymentsConst.PaymentSystem.Adflex
                        || selectedOption.name === '---'
                        || selectedOption.name === 'Invoice'
                        || ($scope.halfCCForm(selectedOption) && !$scope.isCardEditable($scope.ccFormData) && !$scope.cbModel.enterAfterApproval && !$scope.storedCard) //readonly card at org/department level
                        || $scope.cbModel.enterAfterApproval
                    ) {
                        return;
                    }

                    const pendingApproval = $scope.tripData.ApprovalSettings.IsApprovalRequired && !$scope.tripData.IsApproved;

                    if (!(pendingApproval && $scope.isCardExist)) {
                        setTimeout(() => {
                            Spreedly.removeHandlers();

                            /*Spreedly.on('consoleError', function(error) {
                                console.log('Error from Spreedly iFrame: ' + error.msg);
                            });

                            Spreedly.on('errors', function(errors) {
                                for (let i = 0; i < errors.length; i++) {
                                    console.log('Error saving card ' + errors[i].key + ': ' + errors[i].message);
                                }
                            });*/

                            Spreedly.init(appCONST.spreedlyKey, {
                                'numberEl': 'spreedly-number', // eslint-disable-line
                                'cvvEl': 'spreedly-cvv', // eslint-disable-line
                            });

                            function setStyles() {
                                const inputStyle = 'font-size: 14px;font-family: Arial;color: #58595b;vertical-align: middle;margin-top: 3px';

                                Spreedly.setStyle('number', inputStyle);
                                Spreedly.setStyle('cvv', inputStyle);

                                //Spreedly.setStyle('number', 'background-color:yellow');
                                //Spreedly.setStyle('cvv', 'background-color:yellow');
                            }

                            function setRecache(existingToken) {
                                let cardType = null;
                                const type = selectedOption.cardTypeId;

                                if (type === paymentsConst.CardTypes.visaDebit || type === paymentsConst.CardTypes.visaCredit) {
                                    cardType = 'visa';
                                } else if (type === paymentsConst.CardTypes.masterCardDebit || type === paymentsConst.CardTypes.masterCardCredit) {
                                    cardType = 'master';
                                } else if (type === paymentsConst.CardTypes.americanExpress) {
                                    cardType = 'american_express';
                                }

                                Spreedly.setRecache(existingToken, {
                                    'card_type': cardType, // eslint-disable-line
                                    'last_four_digits': selectedOption.formData.Number ? selectedOption.formData.Number.slice(-4) : null, // eslint-disable-line
                                });
                            }

                            Spreedly.on('ready', function() {
                                setStyles();

                                let existingToken = null;
                                if (selectedOption.formData.Id) {
                                    existingToken = selectedOption.formData.Token;
                                } else if ($scope.storedCard) {
                                    existingToken = $scope.storedCard.Token;
                                }

                                if (existingToken) {
                                    setRecache(existingToken);
                                }
                            });

                            function isValidNumber(cardType, type) {
                                if (type === paymentsConst.CardTypes.visaDebit || type === paymentsConst.CardTypes.visaCredit) {
                                    return cardType === 'visa';
                                } else if (type === paymentsConst.CardTypes.masterCardDebit || type === paymentsConst.CardTypes.masterCardCredit) {
                                    return cardType === 'master';
                                } else if (type === paymentsConst.CardTypes.americanExpress) {
                                    return cardType === 'american_express';
                                }
                            }

                            Spreedly.on('fieldEvent', function(name, event, activeElement, inputData) {
                                if (event !== 'input') {
                                    return;
                                }

                                if (!$scope.isCardExist && name === 'number') { // eslint-disable-line
                                    let isValid = false;
                                    if (inputData.validNumber) {
                                        isValid = isValidNumber(inputData.cardType, selectedOption.cardTypeId);
                                    }
                                    if (isValid) {
                                        $scope.numberHalfForm = 'number';
                                        $scope.numberFullForm = 'number';
                                    } else {
                                        $scope.numberHalfForm = '';
                                        $scope.numberFullForm = '';
                                    }
                                }

                                if (name === 'cvv') {
                                    if (inputData.validCvv) {
                                        if (selectedOption.cardTypeId === paymentsConst.CardTypes.americanExpress && inputData.cvvLength === 3) {
                                            $scope.cvvFullForm = '';
                                        } else {
                                            $scope.cvvFullForm = 'cvv';
                                        }
                                    } else {
                                        $scope.cvvFullForm = '';
                                    }
                                }
                            });

                            function actionTrip() {
                                tripFactory.actionTrip(tripOptionsService.TRIP_ACTION.Confirm, $scope.actionData, $scope.tripDetails, $scope.tripData)
                                    .then((response) => {
                                        tripBookingModal.openBookModal(response, $scope, $scope.tripDetails.Id, $scope.tripDetails);
                                        $scope.confirmBookDisabled = true;
                                    })
                                    .catch((error) => {
                                        $scope.confirmBookDisabled = /5\d{2}/.test(error.status);
                                        if ($scope.confirmBookDisabled) {
                                            $scope.tripDetails.Locked = true;
                                        }
                                    })
                                    .finally(() => {
                                        railAmendmentService.unsubscribeFromRebookMode();
                                    });
                            }

                            Spreedly.on('paymentMethod', function(token, paymentMethod) {
                                const data = {};
                                data.Holder = paymentMethod.full_name;
                                data.ExpiryMonth = paymentMethod.month;
                                data.ExpiryYear = paymentMethod.year % 100;
                                data.IssueMonth = paymentMethod.metadata.issueMonth;
                                data.IssueYear = paymentMethod.metadata.issueYear;
                                data.BillingAdress = paymentMethod.address1;
                                data.BillingAdress2 = paymentMethod.address2;
                                data.BillingAdress3 = paymentMethod.shipping_address1;
                                data.City = paymentMethod.city;
                                data.State = paymentMethod.state;
                                data.ZipCode = paymentMethod.zip;
                                data.Description = paymentMethod.metadata.description;
                                data.IssueNumber = paymentMethod.metadata.issueNumber;
                                data.CountryCode = paymentMethod.country;
                                data.LastFourDigits = paymentMethod.last_four_digits;
                                data.Token = token;
                                data.Type = $scope.selectedOption.cardTypeId;
                                if (paymentMethod.metadata.shouldCardBeSaved) {
                                    tripAPI.saveCreditCard(data)
                                        .then((response) => {
                                            data.HolderType = paymentsConst.CardHolderType.user;
                                            if (data.Number) {
                                                data.Number = data.Number.replace(paymentFactory.groupPattern.separator, '');
                                            }

                                            onCreditCardSave(data, response);
                                        })
                                        .finally(() => {
                                            $scope.showWarning = false;
                                        });
                                } else {
                                    $scope.actionData.Token = token;
                                    $scope.actionData.LastFourDigits = paymentMethod.last_four_digits;

                                    actionTrip();
                                }
                            });

                            Spreedly.on('recache', function() {
                                actionTrip();
                            });
                        }, 0);
                    }
                }

                $scope.onSelect = function(selectedOption) {
                    broadcastPaymentCodesEvent();
                    updateTripCosts();
                    updatePaymentForm(selectedOption);

                    $scope.storedCard = null;
                    $scope.cardType = paymentFactory.detectCardType(selectedOption.cardTypeId, selectedOption.paymentMethod);
                    $scope.ccFormData = angular.copy(selectedOption.formData);
                    $scope.isCardExist = !!selectedOption.formData.Id;

                    $scope.numberHalfForm = $scope.isCardExist ? 'number' : '';
                    $scope.numberFullForm = $scope.isCardExist ? 'number' : '';

                    const pendingApproval = $scope.tripData.ApprovalSettings.IsApprovalRequired && !$scope.tripData.IsApproved;
                    $scope.cvvFullForm = pendingApproval ? 'cvv' : '';

                    if (!$scope.isCardExist) {
                        $scope.ccFormData.country = {
                            value: null,
                            text: '---',
                        };
                    } else {
                        formCardNumber();
                        $scope.isCardUpdate = false;
                    }

                    initSpreedly(selectedOption);
                };

                $scope.selectCreditCardType = function(creditCard) {
                    $scope.cardType = paymentFactory.detectCardType(creditCard.cardTypeId, paymentsConst.PaymentMethods.cardType);
                    $scope.ccFormData = angular.copy(creditCard.formData);
                    $scope.isCardExist = !!creditCard.formData.Id;
                };

                $scope.updateCardNumber = function() {
                    if ($scope.tripData.PaymentSystem !== paymentsConst.PaymentSystem.Adflex) {
                        return;
                    }
                    $scope.isCardUpdate = !$scope.isCardUpdate;
                };

                $scope.setDescriptionRequired = function(bool) {
                    $scope.descriptionRequired = bool;
                };

                function onCreditCardSave(data, response) {
                    if (data.Id) {
                        overwriteCard(data);
                    } else {
                        data.Id = response.data.Id;
                        payment.creditCards.push(data);
                    }

                    $scope.paymentOptions = paymentFactory.setPaymentOptions(payment);
                    $scope.selectedOption = $scope.paymentOptions.find((option) => option.cardId === data.Id)
                        || $scope.paymentOptions[0];
                }

                $scope.save = function(formData) {
                    if ($scope.tripData.PaymentSystem !== paymentsConst.PaymentSystem.Adflex && !formData.Id) {
                        const cardData = tripFactory.getCardData(formData, true);
                        return Spreedly.tokenizeCreditCard(cardData);
                    }
                    const data = angular.copy(formData);
                    if ($scope.isCardExist && !Number(data.Number)) {
                            delete data.Number;
                    }

                    data.ExpiryMonth = data.expire.month;
                    data.ExpiryYear = data.expire.year;
                    data.IssueMonth = data.issued ? data.issue.month : '';
                    data.IssueYear = data.issued ? data.issue.year : '';
                    data.CountryCode = data.country.value;
                    data.Type = $scope.selectedOption.cardTypeId;

                    delete data.expires;
                    delete data.expire;
                    delete data.issued;
                    delete data.issue;
                    delete data.country;
                    delete data.cvv;

                    tripAPI.saveCreditCard(data)
                        .then((response) => {
                                data.HolderType = paymentsConst.CardHolderType.user;
                                data.Number = (data.Number || formData.Number).replace(paymentFactory.groupPattern.separator, '');

                                onCreditCardSave(data, response);
                            })
                            .finally(() => {
                                $scope.showWarning = false;
                            });
                };

                $scope.$watch('ccFormData.expires', function(newValue, oldValue) {
                    if (newValue && newValue !== oldValue) {
                        separator(newValue, 'expires', 'expire');
                    }
                });

                $scope.$watch('ccFormData.issued', function(newValue, oldValue) {
                    const parentForm = $scope.checkoutForm;

                    if (!newValue && parentForm.ccForm && parentForm.ccForm.issued && $scope.ccFormData.issue) {
                        $scope.ccFormData.issue.month = '';
                        $scope.ccFormData.issue.year = '';

                        parentForm.ccForm.issued.$setValidity('ccIss', true);
                    }

                    if (newValue && newValue !== oldValue) {
                        separator(newValue, 'issued', 'issue');
                    }
                });

                $scope.$watch('isCardUpdate', formCardNumber);

                function formCardNumber(newValue) {
                    if (!$scope.isCardExist) {
                        return;
                    }

                    if (!newValue) {
                        $scope.ccFormData.Number = ($scope.cardType === 'American Express')
                            ? paymentFactory.groupByPattern($scope.selectedOption.formData.Number, paymentFactory.groupPattern.amEx)
                            .join($scope.ccNumberSeparator)
                            : paymentFactory.groupByPattern($scope.selectedOption.formData.Number, paymentFactory.groupPattern.visa)
                            .join($scope.ccNumberSeparator);
                    } else {
                        $scope.ccFormData.Number = '';
                    }
                }

                function overwriteCard(data) {
                    _.forEach(payment.creditCards, function(card) {
                        if (card.Id === data.Id) {
                            _.forEach(card, function(value, key, cardItem) {
                                cardItem[key] = data[key];
                            });
                        }
                    });
                }

                $scope.$on(tripEvents.TRIP_CHECKOUT_SUBMIT_TRY, function() {
                    $scope.setDescriptionRequired(false);
                    $scope.submitTried = true;

                    /**
                     * When user tried to confirm trip we should check that CVV was specified.
                     * But user also can save card and in this case CVV is not required.
                     * So CVV required only for 3 seconds, user are notified, but after that CVV field returns be
                     * optional, because user might want to save card instead of confirm trip.
                     */
                    $timeout(function() {
                        $scope.submitTried = false;
                    }, 3000);
                });

                $scope.actionData.getPaymentMethod = function() {
                    return $scope.selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice
                        ? paymentsConst.PaymentMethod.invoice
                        : paymentsConst.PaymentMethods.cardCredit;
                };
                $scope.actionData.getCreditCard = function() { // eslint-disable-line
                    if (!$scope.cbModel.enterAfterApproval && !$scope.tripDetails.IsOfflineTrip) {

                        if ($scope.halfCCForm($scope.selectedOption) && !$scope.storedCard) {
                            const request = {
                                Id: $scope.ccFormData.Id || null,
                                CardNumber: $scope.ccFormData.Number,
                                ExpiryMonth: $scope.ccFormData.expire.month,
                                ExpiryYear: $scope.ccFormData.expire.year,
                                Token: $scope.ccFormData.Id ? $scope.ccFormData.Token : $scope.actionData.Token,
                                MaskedNumber: $scope.actionData.LastFourDigits,
                            };

                            request.CreditCardType = ($scope.extraCCType($scope.selectedOption))
                                ? $scope.creditCardType.cardTypeId
                                : $scope.selectedOption.cardTypeId;

                            return request;
                        }

                        if ($scope.ccFormData.Id) {
                            return {
                                Id: $scope.ccFormData.Id,
                                Cvv: $scope.ccFormData.cvv || null,
                                Token: $scope.ccFormData.Token,
                                isFullForm: !!$scope.fullCCForm($scope.selectedOption),
                            };
                        }

                        if ($scope.fullCCForm($scope.selectedOption) && !$scope.storedCard) {
                            return {
                                CreditCardType: $scope.selectedOption.cardTypeId,
                                Id: null,
                                CardNumber: $scope.ccFormData.Number,
                                CardHolderName: $scope.ccFormData.Holder,
                                ExpiryMonth: $scope.ccFormData.expire.month,
                                ExpiryYear: $scope.ccFormData.expire.year,
                                StartMonth: $scope.ccFormData.issued ? $scope.ccFormData.issue.month : '',
                                StartYear: $scope.ccFormData.issued ? $scope.ccFormData.issue.year : '',
                                IssueNumber: $scope.ccFormData.IssueNumber || null,
                                Cvv: $scope.ccFormData.cvv || null,
                                AddressLine1: $scope.ccFormData.BillingAdress,
                                AddressLine2: $scope.ccFormData.BillingAdress2,
                                AddressLine3: $scope.ccFormData.BillingAdress3,
                                City: $scope.ccFormData.City,
                                County: $scope.ccFormData.State,
                                Postcode: $scope.ccFormData.ZipCode,
                                CountryCode: $scope.ccFormData.country.value,
                                Token: $scope.actionData.Token,
                                MaskedNumber: $scope.actionData.LastFourDigits,
                                isFullForm: true,
                            };
                        }

                        if ($scope.storedCard) {
                            if (!$scope.storedCard.IsFullCreditCardDetailsRequired) {
                                return null;
                            }

                            return {
                                Cvv: $scope.ccFormData.cvv,
                                Token: $scope.storedCard.Token,
                            };
                        }
                        return null;
                    }

                    return {
                        CreditCardType: isPaymentMethodInvoice() ? null : $scope.selectedOption.cardTypeId,
                        enterAfterApproval: true,
                    };
                };

                init(true);

                broadcastPaymentCodesEvent();

                function broadcastPaymentCodesEvent() {
                    // if no option, we assume this is an invoice
                    if (!$scope.selectedOption) {
                        $scope.selectedOption = {
                            paymentMethod: paymentsConst.PaymentMethods.invoice,
                        };
                    }
                    const isInvoice = $scope.selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice;
                    const paymentCodesEvent
                        = ($scope.invoiceOnly.value || isInvoice)
                            ? tripEvents.TRIP_SHOW_PAYMENT_CODES
                            : tripEvents.TRIP_HIDE_PAYMENT_CODES;

                    $rootScope.$broadcast(paymentCodesEvent);

                    const hideCardFee = $scope.selectedOption.paymentMethod ? isInvoice : true;
                    $scope.$parent.updateCardFeeVisibility(hideCardFee);
                }

                function updateTripCosts() {
                    const cardType = $scope.selectedOption.cardTypeId;
                    const isInvoice = ($scope.selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice);

                    $rootScope.$broadcast(tripEvents.TRIP_UPDATE_COSTS, {cardType, isInvoice});
                }

                function separator(value, viewKey, modelKey) {
                    if (_.isObject(value)) {
                        $scope.ccFormData[modelKey] = {
                            month: _.padLeft(value.month, 2, '0'),
                            year: _.padLeft(value.year, 2, '0'),
                        };
                        $scope.ccFormData[viewKey]
                            = $scope.ccFormData[modelKey].month + $scope.ccNumberSeparator + $scope.ccFormData[modelKey].year;
                    } else {
                        const date = paymentFactory.makeChunks(value, 2);

                        if (date.length < 2) {
                            if (date[0].length === 2) {
                                $scope.ccFormData[modelKey] = {
                                    month: date[0],
                                    year: '',
                                };
                                $scope.ccFormData[viewKey]
                                    = $scope.ccFormData[modelKey].month + $scope.ccNumberSeparator;
                            } else {
                                $scope.ccFormData[modelKey] = {
                                    month: date[0],
                                    year: '',
                                };
                                $scope.ccFormData[viewKey] = $scope.ccFormData[modelKey].month;
                            }
                        } else {
                            $scope.ccFormData[modelKey] = {
                                month: date[0],
                                year: date[1],
                            };
                            $scope.ccFormData[viewKey]
                                = $scope.ccFormData[modelKey].month + $scope.ccNumberSeparator + $scope.ccFormData[modelKey].year;
                        }
                    }
                }

                function isPaymentMethodInvoice() {
                    return $scope.selectedOption.paymentMethod
                        && $scope.selectedOption.paymentMethod === paymentsConst.PaymentMethods.invoice;
                }

                function setPaymentDetails() {

                    const setPaymentMethodInvoiceAndUpdatePayment = _.flowRight(updatePaymentForm,
                        setPaymentMethodInvoice);
                    const setFullPaymentCardFormDetailsAndUpdatePayment = _.flowRight(updatePaymentForm,
                        setFullPaymentCardFormDetails);
                    const setCardTypeInCardFormDetailsAndUpdatePayment = _.flowRight(updatePaymentForm,
                        setCardTypeInCardFormDetails);
                    const setCreditCardTypeOnAmendProcessAndUpdatePayment = _.flowRight(updatePaymentForm,
                        setCreditCardAndCreditCardType);

                    if (selectedMethodIsInvoice() && $scope.paymentSelectionDisabled) {
                        setPaymentMethodInvoiceAndUpdatePayment();
                    } else if (selectedCreditCardTypeOnAmend()) {
                        setCreditCardTypeOnAmendProcessAndUpdatePayment();
                    } else if (fullCardDetailsProvided()) {
                        setFullPaymentCardFormDetailsAndUpdatePayment();
                    } else if (onlyCardTypeProvided()) {
                        setCardTypeInCardFormDetailsAndUpdatePayment();
                    }

                    function fullCardDetailsProvided() {
                        return $scope.tripData.SelectedCreditCard && $scope.tripData.SelectedCreditCard.CardNumber;
                    }

                    function onlyCardTypeProvided() {
                        return $scope.tripData.SelectedCreditCard;
                    }

                    function setPaymentMethodInvoice() {
                        $scope.selectedOption = _.find($scope.paymentOptions,
                            {paymentMethod: paymentsConst.PaymentMethods.invoice});
                    }

                    function selectedMethodIsInvoice() {
                        return $scope.tripData.IsPaymentTypeInvoice;
                    }

                    function selectedCreditCardTypeOnAmend() {
                        return !$scope.tripData.IsPaymentTypeInvoice
                            && !$scope.tripData.SelectedCreditCard
                            && $scope.tripData.UserCreditCardType;
                    }

                    function getCard(method) {
                        return method.paymentMethod !== paymentsConst.PaymentMethods.invoice
                            && method.cardTypeId === $scope.tripData.SelectedCreditCard.CreditCardType
                            && angular.isUndefined(method.cardId);
                    }

                    function findCreditCardType(option) {
                        return option.paymentMethod === paymentsConst.PaymentMethods.cardCredit
                            && option.cardTypeId === $scope.tripData.UserCreditCardType;
                    }

                    function setFullPaymentCardFormDetails() {
                        $scope.storedCard = $scope.tripData.SelectedCreditCard;

                        $scope.ccFormData = angular.copy($scope.storedCard);
                        if ($scope.ccFormData) {
                            paymentFactory.prepareCountry($scope.ccFormData);
                        }
                        $scope.cardType = paymentFactory.detectCardType($scope.storedCard.CreditCardType, paymentsConst.PaymentMethods.cardCredit);
                        $scope.selectedOption = angular.copy(paymentFactory.detectSelectedCard($scope.paymentOptions, $scope.tripData.SelectedCreditCard));

                        initSpreedly($scope.selectedOption);
                    }

                    function setCardTypeInCardFormDetails() {
                        $scope.selectedOption = angular.copy(_.find($scope.paymentOptions, getCard));
                        $scope.ccFormData.country = {
                            value: null,
                            text: '---',
                        };

                        initSpreedly($scope.selectedOption);
                    }

                    function setCreditCardAndCreditCardType() {
                        $scope.selectedOption = angular.copy(_.find($scope.paymentOptions, findCreditCardType));
                        $scope.ccFormData.country = {
                            value: null,
                            text: '---',
                        };
                    }

                }

                function clearCardType() {
                    $scope.selectedOption.cardTypeId = null;
                }

                function updatePaymentForm(selectedOption) {
                    const option = selectedOption || $scope.selectedOption;
                    $scope.cbModel.showCheckbox = $scope.approvalRequired
                        && $scope.selectedOption.paymentMethod
                        && ($scope.selectedOption.paymentMethod !== paymentsConst.PaymentMethods.invoice || $scope.extraCCType(option))
                        && !$scope.tripData.IsApproved;
                }
    }

    function isPaymentTypeDropdownVisible() {
        return !$scope.invoiceOnly.value
            || !!$scope.tripDetails.IsOfflineTrip;
    }

    function isCreditCardPaymentAlertVisible() {
        return $scope.tripDetails.IsOfflineTrip
            && tripCheckoutPaymentService.isPaymentMethodInvoice($scope.tripData.PaymentMethods);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment/trip-checkout-payment-controller.js